<template>
  <div class="title-bar">
    <div class="title-bar__container">
      <div class="img-l">
        <img
          class="img"
          src="@/assets/images/home/title-bar/title-design.svg"
          alt="title design"
        >
      </div>
      <div class="content">
        <h3><span v-if="titlePrev">{{title}}</span><span class="light">{{titleLight}}</span><span v-if="!titlePrev">{{title}}</span></h3>
        <p>{{desc}}</p>
      </div>
      <div class="img-r">
        <img
          class="img"
          src="@/assets/images/home/title-bar/title-design.svg"
          alt="title design"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleBar',
  props: {
    titlePrev: {
      type: Boolean,
      default: false
    },
    titleLight: String,
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

.mixin-img-design {
  width: 91px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title-bar {
  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    .img-l {
      .mixin-img-design;
    }
    .img-r {
      transform: rotate(180deg);
      .mixin-img-design;
    }
    .content {
      padding: 0 40px;
      text-align: center;
      .light {
        color: @primary-blue;
      }
      h3,
      p {
        margin: 0;
        line-height: 100%;
        color: #333;
      }
      h3 {
        margin-bottom: 16px;
        font-size: 30px;
        font-weight: 500;
      }
      p {
        font-size: 18px;
      }
    }
  }
}
</style>
